<div [ngClass]="{ 'loading-container': true, 'loading-chart': isChart }" 
     *ngIf="showCarregando"
     [ngStyle]="{'height': containerHeight || '100%'}">
  <div class="spinner" 
       [ngStyle]="{'width': spinnerSize || null, 'height': spinnerSize || null}">
  </div>
</div>